var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAverage,
              expression: "showAverage",
            },
          ],
          staticClass: "awardAverageExtraCaseItem-div",
        },
        [
          _c("div", { staticClass: "awardAveragemask" }),
          _c(
            "div",
            {
              staticClass:
                "awardAverageExtraCaseItem-item goods-visible animate__animated animate__zoomIn",
            },
            [
              _c(
                "div",
                {
                  staticClass: "con-gameInstanceBox con-gameInstanceBox-active",
                  on: { click: _vm.onGameInstanceBox },
                },
                [
                  _c("el-image", {
                    staticClass:
                      "con-gameInstanceBox-casePic con-gameInstanceBox-casePic-open",
                    attrs: {
                      src: _vm._f("imgfilter")(_vm.case_details.casePic),
                      fit: "cover",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "con-gameInstanceBox-title flex flex-center-1",
                    },
                    [_c("p", [_vm._v(_vm._s(_vm.case_details.caseName))])]
                  ),
                  _vm._m(0),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("c-unpackgameInstance-item", {
        attrs: {
          type: "average",
          gameInstanceId: _vm.average_case_info.extraCaseId,
          muxiangCaseId: _vm.average_case_info.muxiangCaseId,
        },
        on: { "on-unpackgameInstanceClose": _vm.onUnpackgameInstanceClose },
        model: {
          value: _vm.unpackgameInstance_item_show,
          callback: function ($$v) {
            _vm.unpackgameInstance_item_show = $$v
          },
          expression: "unpackgameInstance_item_show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "con-gameInstanceBox-btn flex flex-center-1" },
      [
        _c(
          "div",
          {
            staticClass:
              "open-case-btn flex flex-center-1 animate__animated animate__heartBeat animate__slower animate__infinite",
          },
          [_vm._v(" 打开 ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }